<!-- src/components/AsistenteVirtual.vue -->
<template>
  <div class="asistente-wrapper" :class="{ 'avoid-footer': avoidFooter }">
    <!-- BURBUJA FLOTANTE POR DEFECTO -->
    <div
      v-if="showBubble && !panelOpen"
      class="asistente-bubble"
      aria-hidden="true"
    >
      ¿Necesitas ayuda?
    </div>

    <!-- ICONO FLOTANTE -->
    <button
      class="asistente-toggle"
      @click="togglePanel"
      aria-label="Abrir asistente"
    >
      <img
        src="@/assets/images/logos/asistente.png"
        alt="Asistente Rodasep"
        class="asistente-icon"
      />
    </button>

    <!-- PANEL DE DIÁLOGO -->
    <div v-if="panelOpen" class="asistente-panel">
      <div class="panel-inner">
        <!-- VISTA DE PREGUNTAS -->
        <div v-if="selectedIndex === null">
          <h4 class="panel-title">
            Hola, soy el asistente de Rodasep<br />
            y estoy aquí para responder tus dudas.
          </h4>
          <ul class="questions">
            <li v-for="(q, i) in questions" :key="i">
              <button class="q-btn" @click="select(i)">
                {{ q.label }}
              </button>
            </li>
          </ul>
        </div>

        <!-- VISTA DE RESPUESTA -->
        <div v-else class="answer-view">
          <button class="back-btn" @click="goBack">← Volver</button>
          <h4 class="answer-title">
            {{ questions[selectedIndex].label }}
          </h4>
          <p class="answer-text">{{ typedText }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { useRoute } from "vue-router";

const panelOpen = ref(false);
const showBubble = ref(true);
const selectedIndex = ref(null);
const typedText = ref("");
const avoidFooter = ref(false);
const route = useRoute();

const questions = [
  {
    label: "¿Cómo puedo cotizar?",
    answer:
      "Para cotizar, selecciona los artículos que necesites desde la pestaña «Productos» o el menú «Rodamientos» (Agrícola, Automotriz, Industrial). Luego haz clic en el botón flotante «Cotiza Aquí» para ir a «Contáctanos». Rellena tus datos, la cantidad de cada producto y cualquier detalle de envío o consulta. Nuestro equipo te enviará tu presupuesto a la brevedad.",
  },
  {
    label: "¿Cómo me envían mis productos una vez cotizados?",
    answer:
      "Después de enviar tu cotización en la pestaña «Contáctanos», nos pondremos en contacto para acordar los detalles de envío: dirección, código postal y método de paquetería. Te informaremos el transportista, el costo y te facilitaremos el número de seguimiento para que puedas seguir tu pedido hasta que lo recibas en tu domicilio.",
  },
  {
    label: "¿En cuántos lugares están ubicados?",
    answer:
      "Estamos en la VII Región:\n- Talca (matriz): Calle 15 Oriente N.º 1016\n- Curicó: Calle Francisco Bilbao Nº39\n- Linares: Calle Yumbel N° 899",
  },
  {
    label: "¿Cómo envío las ubicaciones de los locales a WhatsApp?",
    answer:
      "Es muy fácil: ve a la pestaña «Locales», selecciona tu ciudad (Talca, Curicó o Linares), desplázate hasta el mapa y pulsa el botón verde «Compartir en WhatsApp». Recibirás automáticamente el enlace en tu WhatsApp y podrás abrirlo en Google Maps para navegar directamente hasta nuestro local.",
  },
  {
    label: "¿En que horario atienden?",
    answer:
      "Estamos atendiendo de lunes a viernes de 9:00 a 18:00 horas, recueda que este es nuestro horario de invierno y en verano puede variar.",
  },
];

let bubbleTimer = null;

// Abre el panel si ?assistant=1
function openViaQuery() {
  if (route.query.assistant === "1") {
    panelOpen.value = true;
    showBubble.value = false;
  }
}

function togglePanel() {
  panelOpen.value = !panelOpen.value;
  if (panelOpen.value) {
    showBubble.value = false;
    clearInterval(bubbleTimer);
  } else {
    startBubble();
    selectedIndex.value = null;
  }
}

function startBubble() {
  showBubble.value = true;
  bubbleTimer = setInterval(() => {
    showBubble.value = !showBubble.value;
  }, 3000);
}

function select(i) {
  selectedIndex.value = i;
  typedText.value = "";
  const full = questions[i].answer;
  let idx = 0;
  function typeChar() {
    if (idx < full.length) {
      typedText.value += full[idx++];
      setTimeout(typeChar, 30);
    }
  }
  typeChar();
}

function goBack() {
  selectedIndex.value = null;
  typedText.value = "";
}

onMounted(() => {
  startBubble();
  openViaQuery();
  watch(() => route.query.assistant, openViaQuery);

  const footer = document.querySelector("footer");
  if (footer) {
    const obs = new IntersectionObserver(
      ([e]) => (avoidFooter.value = e.isIntersecting),
      { root: null, threshold: 0.01 }
    );
    obs.observe(footer);
    onUnmounted(() => obs.disconnect());
  }
});

onUnmounted(() => {
  clearInterval(bubbleTimer);
});
</script>

<style scoped>
/* ───────── floatUp animation ───────── */
@keyframes floatUp {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}

/* ───────── floatUp animation ───────── */
@keyframes floatUp {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}

/* ───────── WRAPPER FLOTANTE ───────── */
.asistente-wrapper {
  position: fixed;
  bottom: 10px;
  left: 10px; /* más a la derecha */
  z-index: 1500;
  animation: floatUp 3s ease-in-out infinite;
  transition: bottom 3s ease;
}

/* desktop: evita solaparse con footer */
.asistente-wrapper.avoid-footer {
  bottom: 700px; /* ajusta según tu footer */
}

/* móvil: evita solaparse con footer */
@media (max-width: 768px) {
  .asistente-wrapper.avoid-footer {
    bottom: 1000px; /* ajusta al alto de tu footer en móvil */
  }
}

/* ───────── BURBUJA FLOTANTE ───────── */
.asistente-bubble {
  position: absolute;
  bottom: 74px;
  left: 150%;
  transform: translateX(-50%);
  background: #fff;
  color: #333;
  padding: 0.4rem 0.8rem;
  border: 1px solid #444;
  border-radius: 12px;
  font-size: 0.9rem;
  white-space: nowrap;
}
.asistente-bubble::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 16px;
  border: 8px solid transparent;
  border-top-color: #fff;
}

/* ───────── ICONO FLOTANTE ───────── */
.asistente-toggle {
  background: transparent; /* PNG puro */
  border: none;
  padding: 0;
  cursor: pointer;
  display: block;
}
.asistente-icon {
  width: 56px; /* más grande */
  height: auto;
}

/* hover ligero */
.asistente-toggle:hover .asistente-icon {
  transform: scale(1.05);
}

/* ───────── PANEL DE DIÁLOGO ───────── */
.asistente-panel {
  position: absolute;
  bottom: 10px;
  left: 70px;
  width: 450px;
  background: #2b2b2b;
  border-radius: 20px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  color: #e5e5e5;
}
.panel-inner {
  padding: 1rem;
}

.panel-title {
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
  line-height: 1.3;
}

/* preguntas */
.questions {
  list-style: none;
  margin: 0;
  padding: 0;
}
.questions li + li {
  margin-top: 0.5rem;
}
.q-btn {
  width: 100%;
  background: #3a3a3a;
  border: none;
  padding: 0.3rem;
  text-align: left;
  border-radius: 4px;
  color: #e5e5e5;
  cursor: pointer;
  transition: background 0.2s;
}
.q-btn:hover {
  background: #4e4e4e;
}

/* vista respuesta */
.answer-view .back-btn {
  background: none;
  border: none;
  color: #00a9e0;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.answer-title {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}
.answer-text {
  white-space: pre-wrap;
  font-size: 0.9rem;
  line-height: 1.4;
}

/* ───────── RESPONSIVE ───────── */
@media (max-width: 480px) {
  .asistente-wrapper {
    left: 10px;
  }
  .asistente-icon {
    width: 48px;
  }
  .asistente-panel {
    width: 240px;
    left: 60px;
    bottom: 75px;
  }
  .panel-inner {
    padding: 0.8rem;
  }
}
</style>
